import { IUnit } from '@shared/models/unit';

/** Fallback-Mapping analog zur Backend-Migration (bcm_units.translationKey). */
const UNIT_TRANSLATION_KEY_BY_UNIQUE_NAME: Record<string, string> = {
    kwh: 'types.units.kwh',
    year: 'types.units.year',
    quarter: 'types.units.quarter',
    month: 'types.units.month',
    week: 'types.units.week',
    day: 'types.units.day',
    hour: 'types.units.hour',
    piece: 'types.units.piece',
    t: 'types.units.ton',
    kg: 'types.units.kg',
    g: 'types.units.g',
    l: 'types.units.liter',
    ml: 'types.units.ml',
    m: 'types.units.meter',
    cm: 'types.units.cm',
    sqm: 'types.units.sqm',
    season: 'types.units.season',
    PAX: 'types.units.pax',
    GT: 'types.units.grossTonnage',
    NT: 'types.units.netTonnage',
    flat_rate_unit: 'types.units.flatRate',
    overnight_stay: 'types.units.overnightStay',
    cbm: 'types.units.cbm',
    minute: 'types.units.minute',
    unit: 'types.units.unit',
};

export function resolveUnitTranslationKey(unit: IUnit | null | undefined): string | null {
    if (!unit) {
        return null;
    }

    if (unit.translationKey) {
        return unit.translationKey;
    }

    const uniqueName = unit.uniqueName as string | undefined;
    if (uniqueName && UNIT_TRANSLATION_KEY_BY_UNIQUE_NAME[uniqueName]) {
        return UNIT_TRANSLATION_KEY_BY_UNIQUE_NAME[uniqueName];
    }

    return null;
}
